import axios from 'axios'

const cloudloyaltyUrl = process.env.REACT_APP_CLOUD_LOYALTY_ENDPOINT
const trackingUrl = process.env.REACT_APP_TRACKING_ENDPOINT
const subscriptionKey = process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION
const urlReplaceV1 = process.env.REACT_APP_CLOUD_LOYALTY_URL_REPLACE_V1
const urlReplaceV2 = process.env.REACT_APP_CLOUD_LOYALTY_URL_REPLACE_V2
const refererApi = process.env.REACT_APP_ENVIRONMENT
const onboardingUrl = process.env.REACT_APP_PARTICIPANT_ONBOARDING_ENDPOINT

const composeURL = ({ url, remoteSuffix = '', localSuffix = '' }) => {
  return url && `${url}/${url.indexOf('localhost') > -1 ? localSuffix : remoteSuffix}`
}

const replaceVersion = (url, version, newVersion) => {
  if (!url) return url

  var urlSplitted = url.split('/')
  if (urlSplitted[0] === version) {
    urlSplitted[0] = newVersion
  } else if (urlSplitted[1] === version) {
    urlSplitted[1] = newVersion
  }
  return urlSplitted.join('/')
}

const tracking = {
  client: axios.create({
    baseURL: composeURL({ url: trackingUrl }),
    responseType: 'json'
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          const {
            oidc: {
              user: { access_token: accessToken }
            }
          } = getState()
          req.headers = {
            ...req.headers,
            Authorization: `Bearer ${accessToken}`,
            'Ocp-Apim-Subscription-Key': subscriptionKey,
            'Referer-Api': refererApi
          }
          return req
        }
      ]
    }
  }
}

const mileageApi = {
  client: axios.create({
    baseURL: composeURL({ url: cloudloyaltyUrl }),
    responseType: 'json'
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          const {
            oidc: {
              user: { access_token: accessToken }
            }
          } = getState()
          req.headers = {
            ...req.headers,
            Authorization: `Bearer ${accessToken}`,
            'Ocp-Apim-Subscription-Key': subscriptionKey,
            'Referer-Api': refererApi
          }
          return req
        }
      ]
    }
  }
}

const cloudloyalty = {
  client: axios.create({
    baseURL: composeURL({ url: cloudloyaltyUrl, remoteSuffix: 'cloudloyalty' }),
    responseType: 'json'
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          // TODO: descobrir porque algumas requisições são feitas sem nenhum endpoint
          if (!req.url) { return false }

          if (urlReplaceV1) {
            req.url = replaceVersion(
              req.url,
              'v1',
              urlReplaceV1
            )
          }

          if (urlReplaceV2) {
            req.url = replaceVersion(
              req.url,
              'v2',
              urlReplaceV2
            )
          }

          if (getState().oidc.user) {
            const {
              oidc: {
                user: { access_token: accessToken }
              }
            } = getState()
            req.headers = {
              ...req.headers,
              Authorization: `Bearer ${accessToken}`,
              'Ocp-Apim-Subscription-Key': subscriptionKey,
              'Referer-Api': refererApi
            }
          }

          return req
        }
      ]
    }
  }
}

const onboardingApi = {
  client: axios.create({
    baseURL: composeURL({ url: onboardingUrl }),
    responseType: 'json'
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          const {
            oidc: {
              user: { access_token: accessToken }
            }
          } = getState()
          req.headers = {
            ...req.headers,
            Authorization: `Bearer ${accessToken}`,
            ProjectId: Buffer.from(process.env.REACT_APP_TENANT_ID).toString(
              'base64'
            )
          }
          req.headers = {
            ...req.headers,
            'Ocp-Apim-Subscription-Key':
              process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION
          }
          return req
        }
      ]
    }
  }
}
const solr = {
  client: axios.create({
    baseURL: 'http://solr.dev.ltm.grupoltm.com.br:8984/solr/products',
    responseType: 'json'
  })
}

export default {
  tracking,
  mileageApi,
  cloudloyalty,
  onboardingApi,
  solr
}



// WEBPACK FOOTER //
// ./src/redux/clients.js